// src/views/AboutUs.jsx
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "components/Footers/Footer";
import "../assets/css/AboutUs.css";

// Resimler
import sozlesmeVeBorclar from "../assets/eksiogluPictures/hizmetler/sozlesmeVeBorclar.webp";
import aileHukuku from "../assets/eksiogluPictures/hizmetler/aileHukuku.webp";
import isHukuku from "../assets/eksiogluPictures/hizmetler/isHukuku.webp";
import cezaHukuku from "../assets/eksiogluPictures/hizmetler/cezaHukuku.webp";
import icraHukuku2 from "../assets/eksiogluPictures/hizmetler/icraHukuku2.png";
import mirasHukuku from "../assets/eksiogluPictures/hizmetler/mirasHukuku.webp";
import gayrimenkulHukuku from "../assets/eksiogluPictures/hizmetler/gayrimenkulHukuku.webp";
import idareHukuku from "../assets/eksiogluPictures/hizmetler/idareHukuku.webp";
import denizTicaretiHukuku from "../assets/eksiogluPictures/hizmetler/denizTicaretiHukuku.webp";
import fikriMulkiyetHukuku from "../assets/eksiogluPictures/hizmetler/fikriMulkiyetHukuku.webp";
import gumrukHukuku from "../assets/eksiogluPictures/hizmetler/gumrukHukuku.webp";
import kisiselVerilerinKorunmasıHukuku from "../assets/eksiogluPictures/hizmetler/kisiselVerilerinKorunmasiHukuku.webp";
import rekabetHukuku from "../assets/eksiogluPictures/hizmetler/rekabetHukuku.webp";
import saglikHukuku from "../assets/eksiogluPictures/hizmetler/saglikHukuku.webp";
import sigortaTahkimHukuku from "../assets/eksiogluPictures/hizmetler/sigortaTahkimHukuku.webp";
import ticaretHukuku from "../assets/eksiogluPictures/hizmetler/ticaretHukuku.webp";
import tuketiciHukuku from "../assets/eksiogluPictures/hizmetler/tuketiciHukuku.webp";
import vatandaslikHukuku from "../assets/eksiogluPictures/hizmetler/vatandaslikHukuku.webp";
import vergiHukuku from "../assets/eksiogluPictures/hizmetler/vergiHukuku.webp";
import bilisimHukuku from "../assets/eksiogluPictures/hizmetler/bilisimHukuku.webp";
import sporHukuku from "../assets/eksiogluPictures/hizmetler/sporHukuku.webp";

import eksiogluDarkLogo from "../assets/eksiogluPictures/eksiogluDarkLogo.png";
import {
  FaHandshake,
  FaBalanceScale,
  FaCloud,
  FaAward,
  FaUsers,
  FaGavel,
  FaServer,
} from "react-icons/fa";
import { MdOutlineArrowOutward, MdOutlineArrowRightAlt } from "react-icons/md";
import {
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaYoutube,
  FaWhatsapp,
  FaTelegramPlane,
} from "react-icons/fa";
import ThirdPartyGate from "components/CookieConsent/ThirdPartyGate";

const AboutUs = () => {
  document.body.classList.add("sidebar-collapse");

  useEffect(() => {
    AOS.init({ once: true, duration: 500, easing: "ease-out" });
  }, []);

  useEffect(() => {
    const targetLink = document.querySelector('a[data-gt-lang="tr"]');
    if (targetLink) {
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      if (imgElement) {
        imgElement.src = "https://cdn.gtranslate.net/flags/32/tr.png";
        imgElement.width = 32;
        imgElement.height = 32;
      }
    }
  }, []);

  const cardData = [
    {
      title: "Sözleşmeler ve Borçlar Hukuku",
      imageSrc: sozlesmeVeBorclar,
      link: "/ozel-hukuk/sozlesmeler-ve-borclar-hukuku",
    },
    {
      title: "Aile Hukuku",
      imageSrc: aileHukuku,
      link: "/ozel-hukuk/aile-hukuku",
    },
    {
      title: "İş ve Sosyal Güvenlik Hukuku",
      imageSrc: isHukuku,
      link: "/sosyal-ve-idari-hukuk/is-ve-sosyal-guvenlik-hukuku",
    },
    {
      title: "Ceza Hukuku",
      imageSrc: cezaHukuku,
      link: "/kamu-hukuku/ceza-hukuku",
    },
    {
      title: "İcra İflas Hukuku",
      imageSrc: icraHukuku2,
      link: "/ekonomi-ve-ticaret-hukuku/icra-iflas-hukuku",
    },
    {
      title: "Miras Hukuku",
      imageSrc: mirasHukuku,
      link: "/ozel-hukuk/miras-hukuku",
    },
    {
      title: "Gayrimenkul Hukuku",
      imageSrc: gayrimenkulHukuku,
      link: "/ozel-hukuk/gayrimenkul-hukuku",
    },
    {
      title: "İdare Hukuku",
      imageSrc: idareHukuku,
      link: "/kamu-hukuku/idare-hukuku",
    },
    {
      title: "Vergi Hukuku",
      imageSrc: vergiHukuku,
      link: "/kamu-hukuku/vergi-hukuku",
    },
    {
      title: "Gümrük Hukuku",
      imageSrc: gumrukHukuku,
      link: "/kamu-hukuku/gumruk-hukuku",
    },
    {
      title: "Vatandaşlık Hukuku",
      imageSrc: vatandaslikHukuku,
      link: "/kamu-hukuku/vatandaslik-hukuku",
    },
    {
      title: "Ticaret Hukuku",
      imageSrc: ticaretHukuku,
      link: "/ozel-hukuk/ticaret-hukuku",
    },
    {
      title: "Deniz Ticareti Hukuku",
      imageSrc: denizTicaretiHukuku,
      link: "/ekonomi-ve-ticaret-hukuku/deniz-ticareti-hukuku",
    },
    {
      title: "Rekabet Hukuku",
      imageSrc: rekabetHukuku,
      link: "/ekonomi-ve-ticaret-hukuku/rekabet-hukuku",
    },
    {
      title: "Fikri ve Sınai Mülkiyet Hukuku",
      imageSrc: fikriMulkiyetHukuku,
      link: "/ekonomi-ve-ticaret-hukuku/fikri-mulkiyet-hukuku",
    },
    {
      title: "Tüketici Hukuku",
      imageSrc: tuketiciHukuku,
      link: "/sosyal-ve-idari-hukuk/tuketici-hukuku",
    },
    {
      title: "Sağlık Hukuku",
      imageSrc: saglikHukuku,
      link: "/sosyal-ve-idari-hukuk/saglik-hukuku",
    },
    {
      title: "Spor Hukuku",
      imageSrc: sporHukuku,
      link: "/sosyal-ve-idari-hukuk/spor-hukuku",
    },
    {
      title: "Sigorta (Tahkim) Hukuku",
      imageSrc: sigortaTahkimHukuku,
      link: "/sigorta-tahkim-hukuku",
    },
    {
      title: "Bilişim Hukuku",
      imageSrc: bilisimHukuku,
      link: "/teknoloji-ve-internet-hukuku/bilisim-hukuku",
    },
    {
      title: "Kişisel Verilerin Korunması Hukuku",
      imageSrc: kisiselVerilerinKorunmasıHukuku,
      link: "/teknoloji-ve-internet-hukuku/kisisel-verilerin-korunmasi-hukuku",
    },
  ];

  const data = [
    {
      Icon: FaHandshake,
      title: "Vizyonumuz",
      text: "Ekşioğlu Hukuk Ofisi olarak, İstanbul'un kalbinde hizmet veren lider bir hukuk danışmanlık firması olarak, hukuk sektöründe dünya çapında tanınan ve tercih edilen bir firma olmayı amaçlıyoruz.",
    },
    {
      Icon: FaBalanceScale,
      title: "Misyonumuz",
      text: "Ticaret hukuku, aile hukuku, ceza hukuku gibi çeşitli alanlarda uzman ekibimizle sizlere en iyi hizmeti sunmak için çalışıyoruz. Kurumsal danışmanlıktan bireysel davalara kadar geniş bir yelpazede sunduğumuz hizmetlerle, sektöre yön veren öncü bir kuruluş olarak dünya standartlarında hukuki hizmet sunmayı misyon ediniyoruz.",
    },
    {
      Icon: FaAward,
      title: "Hizmet Kalitemiz",
      text: "Ekşioğlu Hukuk Ofisi olarak, ticaret hukuku, aile hukuku, ceza hukuku ve daha birçok alanda en uygun ve etkili çözümleri sunarak müvekkillerimizin haklarını koruyoruz. Uzmanlığımızı ve deneyimimizi bir araya getirerek, hukuki sorunlarınıza kaliteli ve ekonomik çözümler sunmaktayız.",
    },
    {
      Icon: FaUsers,
      title: "Uzman Kadro",
      text: "Ekşioğlu Hukuk Ofisi olarak, sadece hukuki danışmanlık hizmeti sunmakla kalmayıp, aynı zamanda müvekkillerimizin tüm hukuki ihtiyaçlarında yanlarında olan, konusunda profesyonel bir ekibe sahibiz.",
    },
    {
      Icon: FaGavel,
      title: "Dava ve Takip",
      text: "Müvekkillerimizin davalarının ve diğer hukuki süreçlerinin tam zamanında, istenilen kalitede ve kusursuz şekilde yürütülmesini sağlıyoruz. Müvekkil memnuniyeti açısından en önde gelen hukuk firmalarındanız.",
    },
    {
      Icon: FaCloud,
      title: "Online Altyapı",
      text: "Hukuk danışmanlık firması olarak, hukuki süreçleri destekleyen kapsamlı bir IT altyapısı ile müvekkillerimizin süreçlerini eş zamanlı olarak takip ediyor ve kalite kontrollerini gerçekleştiriyoruz.",
    },
  ];

  const socialMediaData = [
    {
      name: "Instagram",
      handle: "@eksiogluhukukvedanismanlik",
      href: "https://www.instagram.com/eksiogluhukukvedanismanlik/",
      Icon: FaInstagram,
    },
    {
      name: "LinkedIn",
      handle: "Ekşioğlu Hukuk",
      href: "https://www.linkedin.com/company/ek%C5%9Fio%C4%9Flu-hukuk-dan%C4%B1%C5%9Fmanl%C4%B1k/?viewAsMember=true",
      Icon: FaLinkedin,
    },
    {
      name: "Twitter",
      handle: "@eksioglu_hukuk",
      href: "https://x.com/eksioglu_hukuk",
      Icon: FaTwitter,
    },
    {
      name: "Facebook",
      handle: "Ekşioğlu Hukuk",
      href: "https://www.facebook.com/people/Ek%C5%9Fioglu-Hasar-Dan%C4%B1%C5%9Fmal%C4%B1k/61554533796281/?mibextid=ZbWKwL",
      Icon: FaFacebook,
    },
    {
      name: "WhatsApp",
      handle: "Hızlı İletişim",
      href: "https://wa.me/905373233796?text=Merhaba%2C%20bilgi%20alabilir%20miyim%3F",
      Icon: FaWhatsapp,
    },
  ];

  return (
    <>
      <Helmet>
        <title>HAKKIMIZDA | EKŞİOĞLU HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Ekşioğlu Hukuk Ofisi hakkında detaylı bilgi edinin. Hukuki hizmetlerimiz ve uzman kadromuzla size en iyi danışmanlık hizmetini sunuyoruz."
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/hakkimizda"
        />
        <meta property="og:title" content="HAKKIMIZDA | EKŞİOĞLU HUKUK" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="EKŞİOĞLU HUKUK" />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/hakkimizda"
        />
      </Helmet>

      <WhiteNavbar navbarSelection={"about-us"} />
      <div className="mt-[75px]" />

      <section className="w-full flex flex-col items-center bg-white px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-8 md:py-12 font-sans">
        {/* Hakkımızda */}
        <article className="w-full max-w-6xl" data-aos="fade-up">
          <div className="flex items-center mb-6">
            <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
            <h2 className="mx-4 text-2xl md:text-3xl font-extrabold text-slate-900 leading-tight text-center">
              Hakkımızda
            </h2>
            <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
          </div>

          <div className="flex flex-col xl:flex-row md:items-start gap-6">
            <figure className="w-full md:w-[40%] rounded-xl shadow-lg overflow-hidden ring-1 ring-black/5 bg-white">
              <div className="w-full" style={{ aspectRatio: "20 / 11.5" }}>
                <ThirdPartyGate
                  type="video"
                  title="Tanıtım Videosu"
                  height="100%"
                >
                  <iframe
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/rcf3nWEZTSY?si=AbcrQxUvySpq6Yck"
                    title="Ekşioğlu Hukuk Tanıtım Videosu"
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </ThirdPartyGate>
              </div>
              <figcaption className="p-3 text-center text-sm text-slate-600 bg-slate-50 font-sans font-bold">
                Ekşioğlu Hukuk Ofisi
              </figcaption>
            </figure>

            <div className="w-full md:w-[60%] space-y-3">
              <p className="text-base md:text-lg text-gray-700 leading-8 text-justify">
                Ekşioğlu Hukuk ve Danışmanlık olarak, müvekkillerimize en üst
                düzeyde hukuki hizmet sunan öncü bir firmayız. İstanbul'un
                merkezindeki ofisimizden Türkiye'nin 81 iline uzanan hizmet
                anlayışımız ile hem bireysel hem de kurumsal ihtiyaçlara yönelik
                yenilikçi çözümler üretiyoruz.
              </p>

              <p className="text-base md:text-lg text-gray-700 leading-8 text-justify">
                Başta ticaret, aile ve ceza hukuku olmak üzere, uzman kadromuzla
                birçok alanda derin bir bilgi birikimine sahibiz. Anlayışımız
                sadece mevcut anlaşmazlıkları çözmek değil, aynı zamanda
                proaktif ve önleyici danışmanlık hizmetlerimizle olası riskleri
                daha ortaya çıkmadan engellemektir. Her aşamada şeffaf iletişim
                ve titiz takip prensipleriyle, müvekkillerimizin haklarını
                korumayı ve dünya standartlarında hizmet sunmayı amaçlıyoruz.
              </p>
            </div>
          </div>

          <div className="mt-4 space-y-3">
            <p className="text-base md:text-lg text-gray-700 leading-8 text-justify">
              Pratiğimiz; somut ihtiyaçlara uygun çözümler üretmek, karmaşık
              uyuşmazlıklarda hızlı ve etkili stratejiler geliştirmek ve her
              aşamada şeffaf iletişimi sürdürmek üzerine kuruludur. Ekibimiz
              ticaret hukuku, şirketler hukuku, iş hukuku, aile hukuku, ceza
              hukuku, icra ve iflas hukuku, miras hukuku ve gayrimenkul hukuku
              gibi pek çok alanda derin uzmanlığa sahiptir.
            </p>

            <p className="text-base md:text-lg text-gray-700 leading-8 text-justify">
              Hedefimiz yalnızca uyuşmazlıkları çözmek değil; risk doğmadan önce
              proaktif danışmanlık ile önleyici hukuk hizmeti sunmaktır.
            </p>
          </div>
        </article>

        {/* Vizyon - Misyon */}
        <div
          className="w-full max-w-6xl mt-6 flex flex-col "
          data-aos="fade-up"
        >
          <div className="flex items-center mb-6">
            <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
            <h2 className="mx-4 text-2xl md:text-3xl font-extrabold text-slate-900 leading-tight text-center">
              İlkelerimiz
            </h2>
            <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
          </div>
          <div className="aboutUs-ll-wrap">
            <div className="aboutUs-grid2">
              {data.map(({ Icon, title, text }, i) => (
                <div
                  key={i}
                  className="flex-1 md:basis-1/3 rounded-xl bg-white/70 backdrop-blur p-1 md:p-2 shadow-sm ring-1 ring-black/10 transition-transform transition-colors duration-300 hover:bg-white hover:shadow-lg hover:-translate-y-1 hover:ring-[#CA9457]/30"
                >
                  <div className="mb-5 flex justify-center">
                    <div className="h-20 w-20 flex items-center justify-center rounded-md border border-black/10 bg-white">
                      <Icon className="text-3xl text-[#CA9457]" />
                    </div>
                  </div>
                  <h3 className="text-2xl font-extrabold text-slate-900 text-center mb-3">
                    {title}
                  </h3>
                  <p className="text-gray-700 leading-7 text-center">{text}</p>
                  <span className="block mx-auto mt-5 h-0.5 w-0 bg-[#CA9457] transition-[width] duration-300 hover:w-24" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* UZMANLIK ALANLARIMIZ */}
        <section className="w-full flex flex-col items-center bg-white px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 md:py-16 font-sans">
          <div className="w-full max-w-6xl" data-aos="fade-up">
            <div className="flex items-center mb-6">
              <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
              <h2 className="mx-4 text-2xl md:text-3xl font-extrabold text-slate-900 leading-tight text-center">
                Uzmanlık Alanlarımız
              </h2>
              <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
            </div>

            <div className="aboutUs-slider">
              <div className="aboutUs-track">
                {[...cardData, ...cardData].map((c, i) => (
                  <article key={i} className="aboutUs-card font-sans">
                    <div
                      className="aboutUs-card-bg"
                      style={{ backgroundImage: `url(${c.imageSrc})` }}
                      aria-hidden="true"
                    />

                    <button
                      className="aboutUs-card-action"
                      aria-label={`${c.title} sayfasına git`}
                      onClick={() => (window.location.href = c.link)}
                    >
                      <span className="aboutUs-icon-center">
                        <MdOutlineArrowOutward />
                      </span>
                      <span className="aboutUs-label-row">
                        <span className="aboutUs-label-text">Devamını oku</span>
                        <MdOutlineArrowRightAlt className="aboutUs-label-arrow" />
                      </span>
                    </button>

                    <div className="aboutUs-card-content">
                      <div
                        className="aboutUs-card-tag"
                        aria-hidden="true"
                      ></div>
                      <h3 className="aboutUs-card-title">{c.title}</h3>
                    </div>
                  </article>
                ))}
              </div>
            </div>
            <div className="aboutUs-slider-actions">
              <a href="/uzmanlik-alanlari" className="aboutUs-viewall">
                Tümünü Gör
              </a>
            </div>
          </div>
        </section>

        {/* Sosyal Medya Hesaplarımız */}
        <section className="w-full flex flex-col items-center bg-white px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 md:py-16 font-sans">
          <div className="w-full max-w-6xl" data-aos="fade-up">
            <div className="flex items-center mb-6">
              <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
              <h2 className="mx-4 text-2xl md:text-3xl font-extrabold text-slate-900 leading-tight text-center">
                Sosyal Medya Hesaplarımız
              </h2>
              <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              {socialMediaData.map(({ name, handle, href, Icon }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} hesabımızı aç`}
                  className="group flex flex-col items-center text-center 
        w-[40%] sm:w-[30%] md:w-[30%] lg:w-[150px]
        p-3 py-5 rounded-lg
        border border-slate-200 bg-white shadow-sm
        transition-all duration-300
        hover:-translate-y-1 hover:shadow-md
        hover:border-[#CA9457]/60 hover:ring-1 hover:ring-[#CA9457]/30"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="h-[36px] w-[36px] border-2 flex items-center justify-center rounded-full
          bg-slate-50 border border-slate-200
          transition-transform duration-300 group-hover:scale-110"
                  >
                    <Icon className="text-lg text-[#CA9457]" />
                  </div>

                  <h3 className="mt-2 text-sm font-bold text-slate-900">
                    {name}
                  </h3>

                  {/* <p className="text-xs text-slate-600">{handle}</p> */}
                </a>
              ))}
            </div>
          </div>
        </section>
      </section>

      <Footer />
    </>
  );
};

export default AboutUs;
